import styled from 'styled-components';
import { Heading3Mixin, CaptionMixin } from '@qover/typography';

export const SupportCenterButtonContainer = styled.div`
  padding: 2px 10px 2px 2px;
  position: relative;
  display: flex;
  align-items: center;

  > button {
    display: flex;
  }

  :not(.open) {
    overflow: hidden;
  }

  &.open {
    .modal {
      top: 40px;
      opacity: 1;
      z-index: 11;
    }

    .modalMobile {
      position: fixed;
      top: 65px;
      width: 100%;
      box-shadow: 0 1000px 0 1000px rgba(0, 0, 0, 0.5);
    }
  }

  .modal {
    background-color: #fafafb;
    border-radius: 3px;
    width: 370px;
    box-shadow: 0 50px 100px rgba(50, 50, 93, 0.1),
      0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
    position: absolute;
    right: 0;
    -webkit-transition: top 0.3s, opacity 0.3s;
    transition: top 0.3s, opacity 0.3s;
    top: -60px;
    opacity: 0;
    margin-top: 10px;
    z-index: -1;

    @media (-ms-high-contrast: none) {
      &.hide {
        left: 0;
        right: initial;
      }
    }
  }

  .modalMobile {
    top: 100%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.minWidth.S}) {
    padding-right: 20px;
  }
`;

export const IconContainer = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.colors.secondary()};
  border-radius: 50%;
  display: flex;
  height: 40px;
  justify-content: center;
  width: 40px;

  svg {
    fill: white;
    width: 20px;
    height: 20px;
  }
`;

export const ContactMethod = styled.div`
  color: ${({ theme }) => theme.colors.textQuote()};
  flex-shrink: 100;
  margin-left: 10px;
  a {
    outline: none;
  }
`;

export const Row = styled.a`
  display: flex;
  flex-wrap: nowrap;
  line-height: 1em;
  padding: 20px;
  margin-bottom: 1px;
  box-shadow: 0 1px 0 0 rgba(80, 86, 91, 0.2);
  text-decoration: none;

  &:hover {
    background-color: ${({ theme }) => theme.colors.secondary(0.1)};
    text-decoration: none;
  }
`;

export const ContactAction = styled.span`
  ${CaptionMixin};
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const SupportCenter = styled.div`
  margin: 30px;

  svg {
    fill: ${({ theme }) => theme.colors.secondary()};
  }
`;

export const ContactLabel = styled.div`
  ${Heading3Mixin};
  color: ${({ theme }) => theme.colors.secondary()};
  margin-bottom: 4px;
`;

export const MainInfos = styled.div`
  cursor: pointer;
  background-color: white;
  margin-top: 20px;
  box-shadow: 0 1px 3px 0 ${({ theme }) => theme.colors.textQuote(0.2)};
  border-radius: 4px;
`;
